import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';

import React, { useState } from 'react'
import Stand from '../../images/stand.svg'
import Per from '../../images/peroid.svg'
import Dist from '../../images/distance.svg'
import Filter5Icon from '@mui/icons-material/Filter5';
import DangerousIcon from '@mui/icons-material/Dangerous';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ReplayIcon from '@mui/icons-material/Replay';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import NotificationsPausedIcon from '@mui/icons-material/NotificationsPaused';
import GrassIcon from '@mui/icons-material/Grass';
import { Col, Row } from 'react-bootstrap';
import { Battery0Bar, DateRange, SensorsOffSharp, SensorsTwoTone } from '@mui/icons-material';
import MoveDownIcon from '@mui/icons-material/MoveDown';
const moment=require('moment-jalaali')
export function timespanToDhm(timeSpan = '') {
    if (typeof timeSpan !== 'string') {
        return '0';
    }
    const parts = timeSpan.split(':');

    if (parts.length >= 4) {
        const days = parts[0];
        const hours = parts[1]; 
        const minutes = parts[2]; 
        return `${days} روز و \n${hours} ساعت و \n${minutes} دقیقه  \n`;
    } else if (parts.length === 3) {
        const hours = parts[0]; 
        const minutes = parts[1];
        const seconds = parts[2].split('.')[0];

        return `${hours} ساعت و \n${minutes} دقیقه و \n${seconds} ثانیه`;
    } else {
        return '0';
    }
}
const LastPacketListCard = ({item}) => {
    const {lastLogUntilNowTime,differenceLogTime}=item
    const [value,setValue]=useState("1")
    const handleChange=(event,newValue)=>{
        setValue(newValue)
    }
   timespanToDhm("00:06:17.8187035")

  return (
    <div className='  col-sm-12 col-md-12 col-lg-4  gap-3'>
                <div  className='ThemeCard2' data-aos="zoom-out-down" >
                <TabContext value={value}>
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
    <TabList  onChange={handleChange} aria-label="lab API tabs example">
      <Tab label="میانگین" value="1" />
      <Tab label="آخرین پکت" value="2" />
    </TabList>
  </Box>
  <TabPanel value="1">
    <Row className='d-flex gap-2'>
        <Col sm='6'>
        <div className='ThemeCardItem '>
                
                <div style={{display:'flex',flexDirection:'column',alignItems:'center',margin:'12px 0px',backgroundColor:'rgba(0,70,0,0.1)',padding:'5px',borderRadius:'10px',width:'100%'}}>
                <img src={Dist} width={50} height={50}/> 
                <span>فاصله دریافت   </span>
                <span style={{fontSize:'9px',wordBreak:'break-all'}}>{timespanToDhm(lastLogUntilNowTime)}</span>
                </div>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <TrendingUpIcon/>
                </span>
                    </div></div> 
                <span> فعالیت :</span>
                <span>{item?.activity}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <SensorsTwoTone/>
                </span>
                    </div></div>
                <span>  کد سنسور :</span>
                <span>{item?.deviceCode}</span>
            </div>
           
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DangerousIcon/>
                </span>
                    </div></div>
                <span> پکت لاست :</span>
                <span>{item?.lostPacket}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <ReplayIcon/>
                </span>
                    </div></div>
                <span> پکت تکراری :</span>
                <span>{item?.duplicatePacket}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DeviceThermostatIcon/>
                </span>
                    </div></div> 
                <span> دما :</span>
                <span>{+item?.temperature?.toFixed(1)}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <WaterDropIcon/>
                </span>
                    </div></div> 
                <span> رطوبت :</span>
                <span>{+item?.humidity.toFixed(1)}</span>
            </div>
           
        </Col>
        <Col sm='6' >
        <div className='ThemeCardItem'>
                <div style={{display:'flex',flexDirection:'column',alignItems:'center',margin:'12px 0px',backgroundColor:'rgba(0,70,0,0.1)',padding:'5px',borderRadius:'10px',width:'100%'}}
                >                     <img src={Per} width={40} height={40}/> 

                           <span>بازه دریافت </span>
                <span style={{fontSize:'9px'}}>{timespanToDhm(differenceLogTime)}</span>
                </div>
            </div>
        
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <StackedLineChartIcon/>
                </span>
                    </div></div>
                <span> استرس :</span>
                <span>{item?.unrest}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <SensorsTwoTone/>
                </span>
                    </div></div>
                <span>   گردنبند :</span>
                <span>{item?.necklaceNumber}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                <span> جویدن :</span>
                <span>{item?.chewing}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
            <img style={{width:'20px',height:'20px'}}  src={Stand} width={20} height={20}/> 
                </span>
                    </div></div>
                
                <span> ایستادن :</span>
                <span>{item?.standing}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <NotificationsPausedIcon/>
                </span>
                    </div></div>
                <span> خواب :</span>
                <span>{item?.sleeping}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                <span> نشخوار :</span>
                <span>{item?.rumination}</span>
            </div>
        </Col>
    </Row>
            </TabPanel>
  <TabPanel value="2"> <Row className='d-flex gap-2'>
        <Col sm='6' >
        <div className='ThemeCardItem '>
        <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span> زمان لاگ   :</span>
                <span style={{fontSize:'10px'}}>{item?.lastSensorLog?moment(item?.lastSensorLog?.logTime).format('jYYYY-jMM-jDD HH:mm:ss'):0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Filter5Icon/>
                </span>
                    </div></div> 
                <span>   تعداد پکت ها :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.packetCounter:0}</span>
            </div>
            
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Battery0Bar/>
                </span>
                    </div></div>
                <span>  باتری :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.batteryLevel:0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DeviceThermostatIcon/>
                </span>
                    </div></div> 
                <span>  دما :</span>
                <span>{item?.lastSensorLog?+item?.lastSensorLog?.temperature.toFixed(1):0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <WaterDropIcon/>
                </span>
                    </div></div> 
                <span> رطوبت :</span>
                <span>{item?.lastSensorLog?+item?.lastSensorLog?.humidity?.toFixed(1):0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                <span> جویدن :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.chewing:0}</span>
            </div>
           
        </Col>
        <Col sm='6' >
        <div className='ThemeCardItem'>
        <div className='LogoFormT'><div><span>
            <img style={{width:'20px',height:'20px'}} src={Stand} width={20} height={20}/> 
                </span>
                    </div></div>
                <span> ایستادن :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.standing:0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <NotificationsPausedIcon/>
                </span>
                    </div></div>
                <span> خواب :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.sleeping:0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                <span> نشخوار :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.rumination:0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <MoveDownIcon/>
                </span>
                    </div></div>
                <span> تحرک :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.walking:0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <TrendingUpIcon/>
                </span>
                    </div></div>
                <span> فعالیت :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.activity:0}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <StackedLineChartIcon/>
                </span>
                    </div></div> 
                <span> استرس :</span>
                <span>{item?.lastSensorLog?item?.lastSensorLog?.unrest:0}</span>
            </div>
        </Col>
    </Row></TabPanel>
</TabContext>
            
            
            
          </div>
            </div>
  )
}

export default LastPacketListCard
